import { Card, Select, Space } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AcademicYearApiService from '../../../api/AcademicYearApiService';
import SelfStudyApiService from '../../../api/SelfStudyApiService';
import SelfStudyAggregateDataTable from '../../../components/datatables/secondary/SelfStudyAggregateDataTable';
import Dropdown from '../../../components/inputs/Dropdown';
import Breadcrumbs from '../../../config/Breadcrumbs';
import * as GetAcademicYearsHandler from '../../../handlerModels/GetAcademicYearsHandler';
import * as GetSelfStudiesHandler from '../../../handlerModels/GetSelfStudiesHandler';
import AcademicYearDTO from '../../../models/AcademicYearDTO';
import DistrictDTO from '../../../models/DistrictDTO';
import InstitutionDTO from '../../../models/InstitutionDTO';
import RegionalPlanningPartnerDTO from '../../../models/RegionalPlanningPartnerDTO';
import SelfStudyDTO from '../../../models/SelfStudyDTO';
import UserSecurity from '../../../models/UserSecurity';
import HeaderPortal from '../../../portals/HeaderPortal';
import { StateStoreModel } from '../../../redux/state/StateStoreModel';
import DateTimeUtil from '../../../utils/DateTimeUtil';
import HistoryUtil from '../../../utils/HistoryUtil';
import ParameterUtil from '../../../utils/ParameterUtil';

interface SelfStudyAggregateReportPageState {
  loading: boolean;
  fromSelfStudies: boolean;
  academicYear: number;
  academicYears: AcademicYearDTO[];
  fromAcademicYearList: boolean;
  selfStudy: SelfStudyDTO[];
}

interface SelfStudyAggregateReportPageProps {
  currentUser: UserSecurity | null;
  selectedInstitution: InstitutionDTO | null;
  selectedDistrict: DistrictDTO | null;
  selectedRPP: RegionalPlanningPartnerDTO | null;
}

class SelfStudyAggregateReportPage extends React.Component<SelfStudyAggregateReportPageProps & RouteComponentProps<RouteObject>, SelfStudyAggregateReportPageState> {

  constructor(props: SelfStudyAggregateReportPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      loading: false,
      academicYear: 0,
      academicYears: [],
      fromSelfStudies: false,
      fromAcademicYearList: false,
      selfStudy: []
    };
  }

  componentDidMount() {
    const id = Number.parseInt(ParameterUtil.getPathPart(this.props.match, 'academicYearId'));
    this.setState({
      fromAcademicYearList: this.props.match.path.split('/').findIndex(x => x == 'academicYearList') > -1,
      fromSelfStudies: this.props.match.path.split('/').findIndex(x => x == 'selfStudy') > -1
    });

    if (this.state.academicYear != id) {
      this.setState({ academicYear: id, fromSelfStudies: true });
      this.loadSelfStudies(id);

    }
    else {
      this.loadAcademicYears(id);
    }
  }

  private loadAcademicYears = (id: number) => {
    this.setState({ loading: true });
    const request = GetAcademicYearsHandler.Request.create({
      academicYearId: id
    });
    return AcademicYearApiService.getAcademicYears(request)
      .then((results: GetAcademicYearsHandler.Result) => {
        if (results && results.academicYears) {
          this.setState({
            academicYears: results.academicYears ?? [],
            academicYear: DateTimeUtil.getCurrentYear()
          });
        }
      })
      .catch()
      .finally(() => {
        this.setState({ loading: false })
      });
  }

  private loadSelfStudies = (id: number) => {
    const request = GetSelfStudiesHandler.Request.create({
      academicYearId: id ?? 0
    });

    SelfStudyApiService.getSelfStudies(request)
      .then((results: GetSelfStudiesHandler.Result) => {
        if (results) {
          this.setState({
            selfStudy: results.selfStudies ?? []
          });
        }

      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  private onSelect = (value: any) => {
    this.setState({ academicYear: value });
    this.loadSelfStudies(value)
  }


  private onBack = () => {
    HistoryUtil.goBack();
  }

  render() {
    const academicYearId = this.state.academicYear == 0 ? 0 : this.state.academicYear;
    const id = Number.parseInt(ParameterUtil.getPathPart(this.props.match, 'academicYearId'));
    return (
      <Content >
        <HeaderPortal title='Aggregate Report'
          breadcrumbs={Breadcrumbs.aggregateReport(academicYearId)}
          onBack={this.onBack}
          extra={this.state.fromSelfStudies ? null : <Dropdown value={this.state.academicYear} onSelect={this.onSelect} dropdownMatchSelectWidth={false}>{this.state.academicYears.map(x => { return this.renderAcademicYear(x); })}</Dropdown>} />
        < Space direction="vertical" size="large">
          <Card title="Aggregate Report">
            <Space direction='vertical' size="large">
              <SelfStudyAggregateDataTable
                academicYear={id}
                selectedDistrict={this.props.selectedDistrict}
                selectedRPP={this.props.selectedRPP}
                fromSelfStudies={this.state.fromSelfStudies}
                fromAcademicYearList={this.state.fromAcademicYearList} />
            </Space>
          </Card>
        </Space>
      </Content>
    );
  }

  renderAcademicYear(academicYear: AcademicYearDTO) {
    return <Select.Option key={academicYear.id} value={academicYear.id}>{academicYear.id}</Select.Option>
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
    selectedInstitution: state.Institution.Selected,
    selectedDistrict: state.District.Selected,
    selectedRPP: state.RegionalPlanningPartner.Selected
  };
}

export default withRouter(connect(mapStateToProps)(SelfStudyAggregateReportPage));
